import Box from '@ds/components/layout/Box';
import Flex from '@ds/components/layout/Flex';
import Typography from '@ds/components/typography/Typography';
import { LpaIcon } from '@ds/icons/generated/custom';
import React from 'react';

/**
 * The eNVD wordmark + LPA logo lockup shown at the start of the header bar.
 *
 * Rendered on desktop (left of the nav links) and on tablet/mobile (next to the
 * hamburger, when not viewing a consignment).
 */
const Brand: React.FC = () => (
    <Flex
        direction="row"
        align="center"
        gap={2}
    >
        {/* Heading 1 size (24px / 32px, semibold); the element stays the h2 it has always been (ENVDB-9286 item 91).
            color="brand" is --text-brand, which reaches 4.5:1 in both themes (9.5:1 light, 7.7:1 dark), so the
            wordmark no longer leans on the large-text 3:1 (ENVDB-9796 item 109). */}
        <Typography
            variant="heading-1"
            component="h2"
            color="brand"
        >
            eNVD
        </Typography>
        <Box pr={4}>
            <LpaIcon color="var(--brand-primary)" />
        </Box>
    </Flex>
);

Brand.displayName = 'Brand';

export default Brand;
